import { ReactNode } from "react"
import { Box, Spinner, Text, WrapItem } from "@chakra-ui/react"

type PortalDataBoxProps = {
  label: string
  color: string
  background: string
  data: ReactNode | null
}

export default function PortalDataBox({
  label,
  color,
  background,
  data,
}: PortalDataBoxProps) {
  return (
    <WrapItem minW="346px" flex={1}>
      <Box bg={background} rounded="20px" p={4} h="121px" w="100%">
        <Text color={color}>{label}</Text>

        {data ? (
          <Text
            color={color}
            fontSize="54px"
            fontWeight={500}
            fontFamily="riforma.medium"
            lineHeight="70px"
            letterSpacing="-3.24px"
          >
            {data}
          </Text>
        ) : (
          <Box h="70px">
            <Spinner size="lg" />
          </Box>
        )}
      </Box>
    </WrapItem>
  )
}
